export const ALL_ROLES = ["user", "managed-user", "manager", "admin", "support-agent"];

export const Role = {
  USER: "user",
  MANAGED_USER: "managed-user",
  MANAGER: "manager",
  ADMIN: "admin",
  SupportAgent: `support-agent`,
};
